/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * Content management API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FreelancerPerYear
 */
export interface FreelancerPerYear {
    /**
     * 
     * @type {number}
     * @memberof FreelancerPerYear
     */
    year?: number;
    /**
     * 
     * @type {number}
     * @memberof FreelancerPerYear
     */
    nbFreelancers?: number;
}

/**
 * Check if a given object implements the FreelancerPerYear interface.
 */
export function instanceOfFreelancerPerYear(value: object): value is FreelancerPerYear {
    return true;
}

export function FreelancerPerYearFromJSON(json: any): FreelancerPerYear {
    return FreelancerPerYearFromJSONTyped(json, false);
}

export function FreelancerPerYearFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancerPerYear {
    if (json == null) {
        return json;
    }
    return {
        
        'year': json['year'] == null ? undefined : json['year'],
        'nbFreelancers': json['nbFreelancers'] == null ? undefined : json['nbFreelancers'],
    };
}

export function FreelancerPerYearToJSON(value?: FreelancerPerYear | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'year': value['year'],
        'nbFreelancers': value['nbFreelancers'],
    };
}

